import makeActionCreator from 'src/lib/makeActionCreator';

export const OPEN_DIALOG = 'OPEN_DIALOG';
export const CLOSE_DIALOG = 'CLOSE_DIALOG';
export const RESET_DIALOG = 'RESET_DIALOG';

export const openDialog = makeActionCreator(OPEN_DIALOG);
export const closeDialog = makeActionCreator(CLOSE_DIALOG);
export const resetDialog = makeActionCreator(RESET_DIALOG);
